/** Normalize FastAPI `detail` (string | validation object[]) into a user-facing message. */
export function parseApiErrorDetail(detail: unknown): string {
  if (detail == null) return 'Request failed';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const first = detail[0] as { msg?: string; loc?: unknown[] } | undefined;
    if (first?.msg) return first.msg;
    return JSON.stringify(detail);
  }
  if (typeof detail === 'object' && 'msg' in (detail as object)) {
    return String((detail as { msg: string }).msg);
  }
  return String(detail);
}
